/** Touch-first devices — skip heavy scroll animations & observers */
export function isTouchDevice() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(hover: none) and (pointer: coarse)").matches;
}

/** Mobile / tablet viewport — lighter decorative effects */
export function isMobileViewport() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 1023px)").matches;
}

export function shouldReduceMotion() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
  return isTouchDevice() || isMobileViewport();
}

export function shouldSkipScrollObservers() {
  return shouldReduceMotion();
}
